import { useState } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faCheck, faCommentDots, faTimes, faTruckFast } from "@fortawesome/free-solid-svg-icons";
import Pagination from '@mui/material/Pagination';
import { useForm } from "react-hook-form";
import ActionsMenu from "../../../shared/components/ActionsMenu";
import { getActions } from "./actions";
import { cpInPersonVisitRoute } from "./cpRoute";

export default function EntityDetalleTable({
    id, 
    tipo,
    currPage,
    detalles,
    onOpenContactos, 
    onOpenProximoContacto, 
    onOpenAddContacto,
    onOpenAddObservaciones,
    onEditEntidadDetalle,
    onPageChange,
}) {
    const [isEdit, setIsEdit] = useState(false);
    const [currItem, setCurrItem] = useState(null);
    const [currIndex, setCurrIndex] = useState(null);
    const { 
      register,  
      handleSubmit, 
      setValue,
      reset
    } = useForm({
          mode: "onChange",
          defaultValues: {
              nombre: '',
              persona_contacto: '',
              telefono: '',
          }
  });

    const handleChangePage = (event, newPage) => {
      onPageChange(newPage, id);
    }

    const getPaginationCount = () => {
      var totalPages = detalles?.total_items < 15 ? 1 : Math.ceil(detalles?.total_items / 15);
      return totalPages ? parseInt(totalPages) : 0;
    }

    const handleAction = (action, detalle, i) => {
      if(action === 'edit') {
        handleEdit(detalle, i)
      } else if(action === 'next-contact') {
        onOpenProximoContacto(detalle)
      } else if(action === 'add-contact') {
        onOpenAddContacto(detalle)
      } else if(action === 'add-observation') {
        onOpenAddObservaciones(detalle)
      }
    }

    const handleEdit = (item, index) => {
      setIsEdit(true);
      setCurrItem(item);
      setCurrIndex(index);
      reset({
        id: item.id,
        nombre: item.nombre,
        persona_contacto: item.persona_contacto,
        telefono: item.entidad.telefono,
      });
    }
    const cancelEdit = () => {
      setIsEdit(false);
      setCurrItem(null);
      setCurrIndex(null);
      reset();
    }

    const handleChange = (e, attr) => { setValue(attr, e.target.value); }

    const onSubmit = async (data, e) => {
      e.preventDefault();
      onEditEntidadDetalle(data);
    };

    const isFromInPersonVisitRoute = (entity) => {
      if(entity.tipo_cliente_id !== 2) return false;
      return cpInPersonVisitRoute.includes(entity.codigo_postal_facturacion);
    }

    return (
      <div className="w-100 d-flex flex-column align-items-end">
        <form className="form col-12 mb-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>nombre</th>
                  <th>contacto</th>
                  <th>cif</th>
                  <th>teléfono</th>
                  {(id === 'cliente') && <th className="text-center">creado</th>}
                  <th className="text-center">último contacto</th>
                  <th className="text-center">observaciones</th>
                  <th className="text-center">próximo contacto</th>
                  <th className="text-center">volver a contactar</th>
                  {(id === 'cliente' || id === 'lead') && <th className="text-center">último presupuesto</th>}
                  {(id === 'cliente' ) && <th className="text-center">última compra</th>}
                  <th className="text-center">resp.</th>
                  <th className="text-center">acciones</th>
                </tr>
              </thead>

              <tbody>
                { detalles?.items?.map((detalle, i) => {
                  return (
                      <tr key={detalle.id}>
                        <td width={'3%'} className="text-center">
                          <span title="Ver contactos" style={{cursor: 'pointer'}} onClick={() => onOpenContactos(detalle)}>
                            <FontAwesomeIcon icon={faCommentDots} size="1x" className="action" color="#00986C" />
                          </span>
                          {isFromInPersonVisitRoute(detalle.entidad) ? 
                          <span title="Ruta de visitas presencial" className="d-block mt-1">
                            <FontAwesomeIcon icon={faTruckFast} size="1x" className="action" color="#00986C" />
                          </span>
                          : null
                          } 
                        </td>
                        <td width={'20%'}>
                        { isEdit && currIndex === i && currItem.id === detalle.id ?
                            <>
                              <input 
                                type="hidden" 
                                {...register("id")} 
                                defaultValue={detalle?.id || ''}
                              />

                              <input 
                                type="text" 
                                className="form-control" 
                                {...register("nombre")} 
                                defaultValue={detalle?.entidad.nombre || ''}  
                                onChange={(e) => handleChange(e, 'nombre')}
                              />
                            </>
                            :
                            (detalle.entidad.categoria !== 'pendiente' && detalle.entidad.categoria !== 'rf' && detalle.entidad) ?
                            <Link 
                              target="_blank" rel="noopener noreferrer"
                              to={`/cliente/${detalle.entidad.id}`}
                              className={'text-uppercase ' + (tipo === 'no-llamar' ? 'text-danger' : tipo === 'no-piden' ? 'text-warning' : 'text-green')} 
                              title="Ficha Cliente">
                                {detalle.entidad.nombre ? detalle.entidad.nombre : 'Sin nombre'}
                            </Link>
                            : <span 
                                className={'text-uppercase ' + (tipo === 'no-llamar' ? 'text-danger' : tipo === 'no-piden' ? 'text-warning' : '')}>
                                {detalle.entidad.nombre ? detalle.entidad.nombre : 'Sin nombre'}
                              </span>
                          }
                        </td>
                        <td width={'10%'}>
                          { isEdit && currIndex === i && currItem.id === detalle.id ?
                            <input 
                              type="text" 
                              className="form-control" 
                              {...register("persona_contacto")} 
                              defaultValue={detalle?.persona_contacto || ''}  
                              onChange={(e) => handleChange(e, 'persona_contacto')}
                            />
                            : detalle?.persona_contacto
                          }
                        </td>
                        <td width={'7%'}>{detalle.entidad.cif}</td>
                        <td width={'7%'}>
                          { isEdit && currIndex === i && currItem.id === detalle.id ?
                              <input 
                                type="text" 
                                className="form-control" 
                                {...register("telefono")} 
                                defaultValue={detalle.entidad.telefono || ''}  
                                onChange={(e) => handleChange(e, 'telefono')}
                              />
                              : detalle.entidad.telefono
                            }
                        </td>
                        {(id === 'cliente') && <td className="text-center">{detalle?.cliente_creado ? moment(detalle.cliente_creado).format('DD/MM/YYYY') : ''}</td>}
                        <td className="text-center">{detalle?.ultimo_contacto ? moment(detalle.ultimo_contacto).format('DD/MM/YYYY') : '-'}</td>
                        <td className="text-center text-uppercase">{detalle?.ultimas_observaciones ? detalle.ultimas_observaciones : '-'}</td>
                        <td className="text-center">{detalle?.proximo_contacto ? moment(detalle.proximo_contacto).format('DD/MM/YYYY') : '-'}</td>
                        <td width={'7%'} className="text-center">
                          { detalle.volver_contactar === 1 && detalle.proximo_contacto !== null ?
                              <FontAwesomeIcon icon={faCheck} size="1x" className="action" color="#00986C" />
                            : detalle.volver_contactar === 0 && detalle.proximo_contacto === null ?
                              <FontAwesomeIcon icon={faTimes} size="1x" className="action" color="#dc3545" />
                            : '?'
                          }
                        </td>
                        
                        {(id === 'cliente' || id === 'lead') && <td className="text-center">{detalle?.ultimo_presupuesto ? moment(detalle.ultimo_presupuesto).format('DD/MM/YYYY') : '-'}</td>}
                        {(id === 'cliente') && <td className="text-center">{detalle?.ultima_venta ? moment(detalle.ultima_venta).format('DD/MM/YYYY') : '-'}</td>}
                        <td width={'5%'} className="text-center text-uppercase">{detalle?.owner_id ? detalle?.owner?.username : '-'}</td>
                        <td className="text-center">
                          { ((currIndex !== i && currItem?.id !== detalle?.id)) &&
                            <ActionsMenu 
                                options={getActions()}
                                onAction={(action) => handleAction(action, detalle, i)}
                            />
                          }
                          { (isEdit && currIndex === i && currItem.id === detalle.id) &&
                            <div>
                              <button type="submit" className="link">
                                <FontAwesomeIcon icon={faCheck} size="1x" className="action" color="#00986C" />
                              </button>

                              <span title="Cancelar" onClick={() => cancelEdit()}>
                                <FontAwesomeIcon icon={faTimes} size="1x" className="action" color="#dc3545" />
                              </span>
                            </div>
                          }
                        </td>
                      </tr>
                    );
                })}
              </tbody>
            </table>
          </div>
        </form>

          <Pagination 
            id={id}
            className="mt-3" 
            count={getPaginationCount()} 
            page={currPage} 
            onChange={handleChangePage} 
          />
        </div>
    )
}